import { React, useState } from 'react';
import contact from '../assets/images/contact.png'
import { FiMail, FiMapPin, FiPhone } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form';
import useWeb3Forms from '@web3forms/react';

export default function Contact() {
    const [serverResponse, setServerResponse] = useState(null);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting, isValid }
    } = useForm({ mode: 'onChange' });

    const { submit: submitForm } = useWeb3Forms({
        access_key: process.env.REACT_APP_EMAIL_ACCESS_TOKEN,
        settings: {
            from_name: 'Tu Es Belle Foundation',
            subject: 'New Contact Us Message'
        },
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        onSuccess: (message) => {
            setServerResponse({ ok: true, message });
            reset();
            setTimeout(() => {
                setServerResponse(null);
              }, 5000);
        },
        onError: (message) => {
            setServerResponse({ ok: false, message });
            setTimeout(() => {
                setServerResponse(null);
              }, 5000);
        }
    });

  return (
    <>
    <div className="container">
        <div className="row align-items-center">
            <div className="col-md-6">
                <img src={contact} className="img-fluid d-block mx-auto" alt=""/>
            </div>
            <div className="col-md-6">
                <div className="p-4 rounded shadow bg-white ms-lg-5">
                    <h4>Get in touch !</h4>
                    <form className="mt-4" onSubmit={handleSubmit(submitForm)}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="name">
                                        Your Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        {...register('name', { required: 'Name is required.', maxLength: 80 })}
                                        type="text"
                                        className="form-control"
                                        placeholder="your full name"
                                    />
                                    {errors.name && <div className="text-danger mt-1">{errors.name.message}</div>}
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="email">
                                        Your Mail <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        {...register('email', { required: 'Email is required.', pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: "Please your a valid email",
                                        }, })}
                                        id='email'
                                        type="email"
                                        className="form-control"
                                        placeholder="enter email"
                                    />
                                    {errors.email && <div className="text-danger mt-1">{errors.email.message}</div>}
                                </div> 
                            </div>

                            <div className="col-12">
                                <div className="mb-3">
                                <label className="form-label fw-semibold" htmlFor="inquiry">
                                    Subject <span className="text-danger">*</span>
                                </label>
                                <input
                                    {...register('inquiry', { required: 'Subject is required.' })}
                                    type="text"
                                    className="form-control"
                                    placeholder="enter subject"
                                />
                                {errors.inquiry && <div className="text-danger mt-1">{errors.inquiry.message}</div>}
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="body">
                                        Message <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        {...register('body', { required: 'Message is required.' })}
                                        rows="4"
                                        className="form-control"
                                        placeholder="your message">
                                    </textarea>

                                    {errors.body && <div className="text-danger mt-1">{errors.body.message}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="d-grid">
                                    {serverResponse && (
                                        <div className={`alert ${serverResponse.ok ? 'alert-success' : 'alert-danger'}`} role="alert">
                                            {serverResponse.message}
                                        </div>
                                    )}
                                    <button type="submit" className="btn btn-primary" disabled={!isValid || isSubmitting}>
                                        {isSubmitting ? 'Submitting...' : 'Submit Message'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div className="container mt-100 mt-60">
        <div className="row">
            <div className="col-md-4">
                <div className="position-relative features text-center mx-lg-4 px-md-1">
                    <div className="position-relative d-flex justify-content-center">
                        <FiPhone className="fea icon-md text-primary z-1"/>
                        <div className="feature-icon bg-soft-primary position-absolute top-0 translate-middle"></div>
                    </div>

                    <div className="mt-4">
                        <h5 className="mb-3">Phone</h5>
                        <p className="text-muted">Reach out to us. Call or send a messeage and we shall get back to you.</p>
                        <Link to="tel:+256790996936" className="text-primary">+256790996936</Link>
                    </div>
                </div>
            </div>
            
            <div className="col-md-4 mt-5 pt-2 mt-md-0 pt-md-0">
                <div className="position-relative features text-center mx-lg-4 px-md-1">
                    <div className="position-relative d-flex justify-content-center">
                        <FiMail className="fea icon-md text-primary z-1"/>
                        <div className="feature-icon bg-soft-primary position-absolute top-0 translate-middle"></div>
                    </div>

                    <div className="mt-4">
                        <h5 className="mb-3">Email</h5>
                        <p className="text-muted">Send Us an email and we shall reach out immediately</p>
                        <Link to="mailto:tuesbelleus@gmail.com" className="text-primary">tuesbelleus@gmail.com</Link>
                    </div>
                </div>
            </div>
            
            <div className="col-md-4 mt-5 pt-2 mt-md-0 pt-md-0">
                <div className="position-relative features text-center mx-lg-4 px-md-1">
                    <div className="position-relative d-flex justify-content-center">
                        <FiMapPin className="fea icon-md text-primary z-1"/>
                        <div className="feature-icon bg-soft-primary position-absolute top-0 translate-middle"></div>
                    </div>

                    <div className="mt-4">
                        <h5 className="mb-3">Location</h5>
                        <p className="text-muted">We are located in Kampala, Uganda, East Africa.</p>
                        <Link to="https://maps.app.goo.gl/cVG2uAn8m9BmGLv46" className="text-primary" target='_blank'>View on Google map</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>  
    </>
  )
}
